import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgTelegram = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <rect width={23.413} height={23.413} fill="#2FA9E0" rx={11.707} />
      <path
        stroke="#FFF"
        strokeLinejoin="round"
        d="m8.213 12.696 6.322-3.583-4.923 4.144 4.26 3.205c.632.368 1.011.167 1.139-.603.127-.77.665-3.363 1.615-7.779.327-1.059-.018-1.398-1.034-1.017s-4.276 1.618-9.78 3.71c-.857.477-1.014.811-.472 1.003.543.192 1.5.524 2.873.995.49 1.683.783 2.666.879 2.948.144.424.52.614.52.307v-2.763l1.722 1.288-1.722 1.592"
      />
    </g>
  </svg>
);
const Memo = memo(SvgTelegram);
export default Memo;
